// Chiamate dell'area clienti al nostro server (/api/portal). Il cliente non usa Supabase direttamente.
const KEY = 'td_area_clienti'

export const session = {
  get() { try { return localStorage.getItem(KEY) } catch (e) { return null } },
  set(t) { try { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY) } catch (e) {} },
}

export class ApiError extends Error {
  constructor(status, message) { super(message); this.status = status }
}

let onExpired = () => {}
export const setOnExpired = (fn) => { onExpired = fn }

export async function api(method, path, body) {
  const headers = {}
  const token = session.get()
  if (token) headers.Authorization = `Bearer ${token}`
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  let res
  try {
    res = await fetch('/api/portal' + path, { method, headers, body: body !== undefined ? JSON.stringify(body) : undefined })
  } catch (e) {
    throw new ApiError(0, 'Connessione non riuscita: controlla la rete e riprova.')
  }
  const out = await res.json().catch(() => ({}))
  if (!res.ok) {
    // Sessione scaduta o password cambiata: si torna all'accesso
    if (res.status === 401 && token) { session.set(null); onExpired() }
    throw new ApiError(res.status, out.error || `Errore ${res.status}`)
  }
  return out
}

export const MAX_FILE_MB = 25
export const MAX_FILES = 10

export function checkFiles(files) {
  if (files.length > MAX_FILES) return `Puoi allegare al massimo ${MAX_FILES} file.`
  const big = files.filter(f => f.size > MAX_FILE_MB * 1024 * 1024).map(f => f.name)
  if (big.length) return `Superano ${MAX_FILE_MB} MB: ${big.join(', ')}.`
  const empty = files.filter(f => !f.size).map(f => f.name)
  if (empty.length) return `File vuoti: ${empty.join(', ')}.`
  return null
}

// Carica i file direttamente nello storage con un link valido solo per quel percorso
export async function uploadFiles(files) {
  const done = []
  for (const f of files) {
    const { path, uploadUrl } = await api('POST', '/upload-url', { name: f.name, size: f.size, type: f.type })
    const form = new FormData()
    form.append('cacheControl', '3600')
    form.append('', f)
    let r
    try {
      r = await fetch(uploadUrl, { method: 'PUT', body: form })
    } catch (e) {
      throw new ApiError(0, `Caricamento di "${f.name}" non riuscito: controlla la connessione.`)
    }
    if (!r.ok) throw new ApiError(r.status, `Caricamento di "${f.name}" non riuscito.`)
    done.push({ path, name: f.name })
  }
  return done
}

// Screenshot incollati con Ctrl+V
export function filesFromClipboard(e) {
  const items = Array.from(e.clipboardData?.items || [])
  return items.filter(i => i.kind === 'file').map(i => i.getAsFile()).filter(Boolean).map((f, n) => {
    if (f.name && f.name !== 'image.png') return f
    const ext = (f.type.split('/')[1] || 'png').replace('jpeg', 'jpg')
    const stamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')
    return new File([f], `immagine-${stamp}${n ? '-' + n : ''}.${ext}`, { type: f.type })
  })
}
